import { GET_PUBLICITY_ALL ,GET_LIST_CATEGORY,SERCH_GET_PUBLICITY , GET_PUBLICITY_ID} from "../graphql/query/publicity/query";
import { apiRequest , apiRequests} from "../services/api";
import { CREATE_PUBLICITY_NEW , SEND_PUBLICITY_TECH , UPDATE_PUBLICITY} from "../graphql/mutations/publicity/mutations";

/** QUERY */
export const getPublicityId = async (id) => {
    try{
        const variables = {
            id: id
        }
        const response = await apiRequests(GET_PUBLICITY_ID, variables);
        //console.log('respuest P :',response);
        return response;
    } catch(err){
        console.log('Fallas en el fronted :',err);
        return [];
    }
};

export const getPublicityAll = async()=>{
    try {
        const response = await apiRequest(GET_PUBLICITY_ALL);
        
        if(response.data.getPublicityAll.publicity != [] ){
            return response.data.getPublicityAll.publicity;
        }else{
            console.error('no hay publicidades' );
            return response.data.getPublicityAll.publicity;
        }
    } catch (error){
        console.error('problemas en el fronted' );
    }
};

export const getListPublicity = async () =>{
    try {
        const response = await apiRequests(GET_LIST_CATEGORY);
        //console.log('cat',response);
        if(response.data && response.data.getAllCategory){
            const filteredCategories = response.data.getAllCategory.filter(category => category.entity_type === 'publicity');
            return filteredCategories;
        }
        
    } catch(error){
        console.warn('Fallas en el servidor.', error );
        return [];
    } 
};

export const filtersPublicity = async(filter={}) => {
    try {
        const variables = {
            searchParameter:filter
        };

        const response = await apiRequests(SERCH_GET_PUBLICITY,variables);
        //console.log('response P:',response);
        if(response.data.searchPublicity.publicity != null){ 
            return response.data.searchPublicity.publicity;
        }else {
            console.log('Fallas en el servidor backend',response.data.searchPublicity.message);
            return [];
        }
    } catch(error){
        console.warn('Fallas en el servidor fronted.', error);
    }
};

/** MUTATIONS */

export const createPublicityNew = async (variabless) => {
    try{
        //console.log(variabless);
        const response1 = await apiRequests(CREATE_PUBLICITY_NEW,variabless);
        //console.log("✅ Publicidad creada:", response1);
        return response1;
    } catch (error) {
        console.warn('Se presentaron las siguientes fallas :' , error)
        return null;;
    }
};

export const sendPublicity = async (id) => {
    const userRaw = localStorage.getItem("user");
    const user = JSON.parse(userRaw);


    try {
        const variables = {
            id_p: id ,
            id_a: user.id
        };
        
        const response = await apiRequests(SEND_PUBLICITY_TECH,variables);
        //console.log('123',response.data.sendPublicity.state);
        return response.data.sendPublicity.state;
    } catch (err){
        console.warn('Se presento una falla al envio de notificaciones.');
        return null;
    }
};

export const updatedPublicity = async (id, requestPublicity, logo) => {
  try {
    const variables = {
      id,
      requestPublicity,
      logo
    };
    //console.log('ab' , variables);
    const response = await apiRequests(UPDATE_PUBLICITY, variables);
    //console.log('cd' , response);
    return response?.data?.updatePublicity;
  } catch (err) {
    console.warn("Se presentó una falla al actualizar la publicidad.", err);
    return null;
  }
};